/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneLink from 'base/components/standalone/Link';

export const DynamicStandaloneLink = StandaloneLink;
export type DynamicStandaloneLinkProps = PropsFromComponent<typeof StandaloneLink>;

export const DynamicStandaloneLinkWith = (extras: DynamicStandaloneExtras): typeof StandaloneLink => {
    return function DynamicStandaloneLink(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Link');
        return <StandaloneLink {...mergeProps({ options: { theme } }, props)} />;
    }
}